<template>
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <div v-else>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">

                        </th>
                        <th class="text-left">
                            Barcode
                        </th>
                        <th class="text-left">
                            Species
                        </th>
                        <th class="text-left">
                            Weight
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="item in availableMonthlyPools"
                        :key="item.MonthlyPoolID"
                    >
                        <td>
                            <v-checkbox v-model="item.Selected"></v-checkbox>
                        </td>
                        <td>{{ item.Barcode }}</td>
                        <td>{{ item.SpeciesFullName }}</td>
                        <td>{{ item.TotalWeight || 0}}g</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="4" class="text-center">
                            <v-btn
                                color="success"
                                :disabled="!atLeastOneMonthlyPoolSelected"
                                :loading="saving || loading"
                                @click="addSelected"
                            >
                                Add Selected
                            </v-btn>
                        </td>
                    </tr>
                </tfoot>
            </template>
        </v-simple-table>
        <div v-if="addMonthlyPoolErrors.length > 0">
            <v-alert text type="error">
                <v-row align="center">
                    <v-col class="grow">
                        <ul>
                            <li
                                v-for="(error, errorIndex) in addMonthlyPoolErrors"
                                :key="errorIndex"
                            >
                                {{error.Barcode ? (error.Barcode + " - ") : ""}}{{error.message}}
                            </li>
                        </ul>
                    </v-col>
                    <v-col class="shrink">
                        <v-btn @click="loadData">Reload Available Monthly Pools</v-btn>
                    </v-col>
                </v-row>
            </v-alert>
        </div>
    </div>
</template>

<script>
import * as venomPoolingAPI from "@/services/venomPoolingAPI";
import constants from 'comunet-btg-utah-repository-shared/constants';
import moment from 'moment';

export default {
    components: {
        
    },
    props: {
        speciesID: {
            type: Number,
            default: -1
        },
        speciesBatchPoolID: {
            type: Number,
            default: -1
        },
        isExternal: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            loading: false,
            saving: false,
            availableMonthlyPools: [],
            addMonthlyPoolErrors: []
        }
    },
    computed: {
        atLeastOneMonthlyPoolSelected() {
            return this.selectedMonthlyPools.length > 0;
        },
        selectedMonthlyPools() {
            return this.availableMonthlyPools.filter(mp => mp.Selected);
        }
    },
    methods: {
        async loadData() {
            this.loading = true;
            this.addMonthlyPoolErrors = [];
            
            try {
                let data = await venomPoolingAPI.getMonthlyPoolsAvailableForSpeciesBatchPools(this.speciesID, this.isExternal);
                
                data.sort((a, b) => {
                    return a.Barcode - b.Barcode
                });

                data = data.map(mp => {
                    mp.Selected = false;

                    return mp;
                });

                this.availableMonthlyPools = data;
            }
            catch (e) {
                this.addMonthlyPoolErrors.push(e);
            }
            finally {
                this.loading = false;
            }
        },
        async addSelected() {
            this.saving = true;
            this.addMonthlyPoolErrors = [];

            try {
                await venomPoolingAPI.addMonthlyPoolsToSpeciesBatchPool(
                    this.selectedMonthlyPools.map(mp => mp.MonthlyPoolID),
                    this.speciesBatchPoolID
                );

                this.loadData();

                this.$emit("recordsAdded");
            }
            catch (e) {
                this.addMonthlyPoolErrors.push(e);
            }
            finally {
                this.saving = false;
            }
        }
    },
    async created() {
        await this.loadData();
    }
}
</script>